import React, { useRef, useState, useEffect } from 'react';
import { NavLink as Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { Button, Input, Modal, Form, message, Skeleton, Progress, Radio, Select } from 'antd';
import { useCookies } from 'react-cookie';
import MaskedInput from 'react-text-mask';
import emailMask from 'text-mask-addons/dist/emailMask';
import ReactCodeInput from "react-code-input";
import { useSelector, useDispatch } from 'react-redux';
import { setLoading, setActive_modal } from '../../redux/app_global/reducer';
import { setLocation } from '../../redux/locations/reducer';
import { setToken, setRegistration } from '../../redux/profile/reducer';
import { SETTINGS_APP } from "../../params";
import users from './users';
import {
    SearchOutlined,
    MenuOutlined,
    CloseOutlined,
    CloseCircleOutlined,
    EyeOutlined,
    EyeInvisibleOutlined,
    UserOutlined
} from '@ant-design/icons';
import { MdOutlineHomeWork } from "react-icons/md";
import { BsChevronDown } from "react-icons/bs";

import { getLocations } from "../../API/locations";
import { getOrganizationCategoriesList } from "../../API/organization";
import { authorization, registration, forgot, getProfile, forgot_code, forgot_password } from '../../API/profile';

export const Header = props => {

    const dispatch = useDispatch();
    const app_global = useSelector(state => state.app_global);
    const locations = useSelector(state => state.locations);
    const profile = useSelector(state => state.profile);

    const isInitialMount = useRef(true);
    const inputRef = useRef(null);
    const inputMobRef = useRef(null);
    const inputSearchRef = useRef(null);
    const refLinkOrgs = useRef(null);
    const [activeMenu, setActiveMenu] = useState(false);
    const [activeCity, setActiveCity] = useState(false);
    const [activeSearch, setActiveSearch] = useState(false);
    const [searchCity, setSearchCity] = useState('');
    const [clientCityName, setClientCityName] = useState('Нижний Новгород');
    const [clientCityId, setClientCityId] = useState('1321');
    const [cookies, setCookie, removeCookie] = useCookies(['token','city_name','city_id']);
    const [activeTypeAuth, setActiveTypeAuth] = useState("email");
    const [activeTypeForgot, setActiveTypeForgot] = useState("email");

    const [form_authorization] = Form.useForm();
    const [form_registration] = Form.useForm();
    const [form_forgot] = Form.useForm();
    const [form_password] = Form.useForm();

    const [password_complexity, setPassword_complexity] = useState(0);
    const [tempForgotEmail, setTempForgotEmail] = useState("");
    const [tempForgotCode, setTempForgotCode] = useState("");

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

            component_start();
        }
    }, []);

    useEffect(async () => {
        if (profile.token) {
            dispatch(setLoading(true));
            await getProfile({},dispatch,profile)
            .then(async json => {
                console.log ( `%c [API]: [getProfile]`, `color: #A366FF`, json );
                if (json?.code) {
                    // Done
                } else {
                    message.error('Сессия закрыта');
                    removeCookie('token', { path: '/' });
                    dispatch(setToken(''));
                }
                dispatch(setLoading(false));
            });
        }
    }, [profile.token]);

    async function component_start() {
        await getLocations({},dispatch,profile)
        .then(async json => {
            console.log ( `%c [API]: [getLocations]`, `color: #A366FF`, json );
        });
        await getOrganizationCategoriesList({},dispatch,profile)
        .then(async json => {
            console.log ( `%c [API]: [getOrganizationCategoriesList]`, `color: #A366FF`, json );
        });

        dispatch(setLoading(false));

        if (cookies.city_name && cookies.city_id) {
            setClientCityName(cookies.city_name);
            setClientCityId(cookies.city_id);
            dispatch(setLocation({
                city_name: cookies.city_name,
                city_id: cookies.city_id,
            }));
        }

        if (cookies.token) {
            dispatch(setToken(cookies.token));
        }
    }

    async function clickCity() {
        if (activeCity) {
            setActiveCity(!activeCity);
            setTimeout(async () => {
                inputRef.current.blur();
            }, 100);
        } else {
            setActiveCity(!activeCity);
            setTimeout(async () => {
                inputRef.current.focus();
            }, 100);
        }
    }

    async function clickCityMob() {
        if (activeCity) {
            setActiveCity(!activeCity);
            setTimeout(async () => {
                inputMobRef.current.blur();
            }, 100);
        } else {
            setActiveCity(!activeCity);
            setTimeout(async () => {
                inputMobRef.current.focus();
            }, 100);
        }
    }

    async function clickSearch() {
        if (activeSearch) {
            setActiveSearch(!activeSearch);
            setTimeout(async () => {
                inputSearchRef.current.blur();
            }, 100);
        } else {
            setActiveSearch(!activeSearch);
            setTimeout(async () => {
                inputSearchRef.current.focus();
            }, 100);
        }
    }

    function searchCityF(e) {
        setSearchCity(e.target.value.replace(/\s+/g,' '));
    }

    function changeCity(city) {
        setClientCityName(city.city);
        setClientCityId(city.id);
        setActiveCity(false);
        setCookie('city_name', city.city, { path: '/' });
        setCookie('city_id', city.id, { path: '/' });
        dispatch(setLocation({
            city_name: city.city,
            city_id: city.id,
        }));
    }

    var obj = {
        get city () {
            if ( locations.locations.length > 0 ) {
                let search = searchCity.toLowerCase();
                return locations.locations.filter( function( item ) {
                    return(
                        item['city'].toLowerCase().indexOf( search ) > -1
                    );
                } )/*.slice(0, 19)*/;
            } else {
                return locations.locations.slice(0, 19);
            }
        },
    };

    //* Авторизация
    async function showModalAuthorization() {
        setActiveMenu(false);

        form_authorization.resetFields();
        dispatch(setActive_modal('authorization'));
    }

    async function closeModalAuthorization() {
        dispatch(setActive_modal(''));
        await form_authorization.resetFields();
    }

    async function form_finish_authorization(v) {
        v['login'] = v['login'].replace(/ /ig, "").replace(/\+/ig, "");

        await authorization(v,dispatch,profile)
        .then(async json => {
            console.log ( `%c [API]: [authorization]`, `color: #A366FF`, json );
            if (json?.code) {
                message.success('Вы авторизовались!');
                setCookie('token', json?.result?.token, { path: '/' });
                dispatch(setToken(json?.result?.token));
                closeModalAuthorization();
            } else {
                let error = [];
                if (json.error[0]) {
                    error.push(json.error[0]);
                }
                if (json.error[1]) {
                    error.push(json.error[1]);
                }
                if (json.error[3]) {
                    error.push((json.error[3]).join(', '));
                }
                message.error(error.join('. '));
            }
        });
    }

    //* Восстановление доступа
    async function showModalForgotCode() {
        dispatch(setActive_modal('forgotProfileCode'));
    }

    async function closeModalForgotCode() {
        dispatch(setActive_modal(''));
    }

    async function form_finish_forgot_code(e) {
        if (e.length === 6) {
            await forgot_code({
                login:tempForgotEmail,
                code:e
            },dispatch,profile)
            .then(async json => {
                console.log ( `%c [API]: [forgot_code]`, `color: #A366FF`, json );
                if (json?.code) {
                    dispatch(setActive_modal('forgotProfilePassword'));
                    setTempForgotCode(e);
                } else {
                    let error = [];
                    if (json.error[0]) {
                        error.push(json.error[0]);
                    }
                    if (json.error[1]) {
                        error.push(json.error[1]);
                    }
                    if (json.error[3]) {
                        error.push((json.error[3]).join(', '));
                    }
                    message.error(error.join('. '));
                }
            });
        }
    }

    //* Регистрация
    async function showModalRegistration() {
        form_registration.setFieldsValue({
            firstname: '',
            lastname: '',
            phone: '',
            email: '',
        });
        dispatch(setActive_modal('registration'));
    }

    async function closeModalRegistration() {
        dispatch(setActive_modal(''));
        await form_registration.resetFields();
        await dispatch(setRegistration({}));
    }

    //* Регистрация
    async function form_finish_registration(v) {
        if (v['password'] !== v['password_repeat']) {
            message.error('Пароли не совпадают!');
            return true;
        }
        if (v['phone']) {
            v['phone'] = Number((v['phone']).replace(/\D+/g,""));
        }
        await registration(v,dispatch,profile)
        .then(async json => {
            console.log ( `%c [API]: [registration]`, `color: #A366FF`, json );
            if (json?.code) {
                message.success('Вы зарегистрировались!');
                setCookie('token', json?.result?.token, { path: '/' });
                dispatch(setToken(json?.result?.token));
            } else {
                let error = [];
                if (json.error[0]) {
                    error.push(json.error[0]);
                }
                if (json.error[1]) {
                    error.push(json.error[1]);
                }
                if (json.error[3]) {
                    error.push((json.error[3]).join(', '));
                }
                message.error(error.join('. '));
            }
        });
    }

    //* Восстановление пароля
    async function showModalForgot() {
        form_forgot.setFieldsValue({
            login: '',
            type: activeTypeForgot
        });
        dispatch(setActive_modal('forgot'));
    }

    async function closeModalForgot() {
        dispatch(setActive_modal(''));
        await form_forgot.resetFields();
    }

    async function form_finish_forgot(v) {
        v['login'] = v['login'].replace(/ /ig, "").replace(/\+/ig, "");

        await forgot(v,dispatch,profile)
        .then(async json => {
            console.log ( `%c [API]: [forgot]`, `color: #A366FF`, json );
            if (json?.code) {
                message.success('Вам отправлен код');
                setTempForgotEmail(v['login']);
                showModalForgotCode();
            } else {
                let error = [];
                if (json.error[0]) {
                    error.push(json.error[0]);
                }
                if (json.error[1]) {
                    error.push(json.error[1]);
                }
                if (json.error[3]) {
                    error.push((json.error[3]).join(', '));
                }
                message.error(error.join('. '));
            }
        });
    }

    //* Изменение пароля
    async function closeModalForgotPassword() {
        dispatch(setActive_modal(''));
    }

    async function form_finish_profile_password(v) {
        if (checkPassword(v['password_new']) < 100) {
            message.error('Пароль недостаточно сложный');
            return false;
        }

        v['code'] = tempForgotCode;
        v['login'] = tempForgotEmail,
        await forgot_password(v,dispatch)
        .then(async json => {
            console.log ( `%c [API]: [forgot_password]`, `color: #A366FF`, json );
            if (json?.code) {
                message.success('Пароль изменен');
                showModalAuthorization();
            } else {
                let error = [];
                if (json.error[0]) {
                    error.push(json.error[0]);
                }
                if (json.error[1]) {
                    error.push(json.error[1]);
                }
                if (json.error[3]) {
                    error.push((json.error[3]).join(', '));
                }
                message.error(error.join('. '));
            }
        });
    }

    const randomUser = users[Math.floor(Math.random() * (users.length - 0)) + 0];

    function checkPassword(e = '') {
        var s_letters = "qwertyuiopasdfghjklzxcvbnm"; // Буквы в нижнем регистре
        var b_letters = "QWERTYUIOPLKJHGFDSAZXCVBNM"; // Буквы в верхнем регистре
        var digits = "0123456789"; // Цифры
        var specials = "!@#$%^&*()_-+=\|/.,:;[]{}"; // Спецсимволы

        var is_s = false; // Есть ли в пароле буквы в нижнем регистре
        var is_b = false; // Есть ли в пароле буквы в верхнем регистре
        var is_d = false; // Есть ли в пароле цифры
        var is_sp = false; // Есть ли в пароле спецсимволы
                
        for (var i = 0; i < e.length; i++) {
            /* Проверяем каждый символ пароля на принадлежность к тому или иному типу */
            if (!is_s && s_letters.indexOf(e[i]) != -1) {
                is_s = true
            }
            else if (!is_b && b_letters.indexOf(e[i]) != -1) {
                is_b = true
            }
            else if (!is_d && digits.indexOf(e[i]) != -1) {
                is_d = true
            }
            else if (!is_sp && specials.indexOf(e[i]) != -1) {
                is_sp = true
            }
        }

        var rating = 0;
        if (is_s) rating++; // Если в пароле есть символы в нижнем регистре, то увеличиваем рейтинг сложности
        if (is_b) rating++; // Если в пароле есть символы в верхнем регистре, то увеличиваем рейтинг сложности
        if (is_d) rating++; // Если в пароле есть цифры, то увеличиваем рейтинг сложности
        if (is_sp) rating++; // Если в пароле есть спецсимволы, то увеличиваем рейтинг сложности
        /* Далее идёт анализ длины пароля и полученного рейтинга, и на основании этого готовится текстовое описание сложности пароля */

        var score = 0;
        if (e.length < 6 && rating < 3) {
            score = 10;
        }
        if (e.length === 0) {
            score = 0;
        }
        else if (e.length < 6 && rating >= 3) {
            score = 50;
        }
        else if (e.length >= 8 && rating < 3) {
            score = 50;
        }
        else if (e.length >= 8 && rating >= 3) {
            score = 100;
        }
        else if (e.length >= 6 && rating == 1) {
            score = 10;
        }
        else if (e.length >= 6 && rating > 1 && rating < 4) {
            score = 50;
        }
        else if (e.length >= 6 && rating == 4) {
            score = 100;
        };

        setPassword_complexity(score);
        return score;
    }

    function onChangePassword(e) {
        checkPassword(e.target.value)
    }

    return (
        <>
        <Link ref={refLinkOrgs} to='/org' exact={ true } onClick={() => scroll.scrollToTop()}></Link>
        <Modal mask centered className="modal_custom modal_authorization" key="m_forgot_password" width={700} title="Восстановление доступа" open={app_global.active_modal === 'forgotProfilePassword'} onOk={() => closeModalForgotPassword()} onCancel={() => closeModalForgotPassword()} footer={null}>
                <div className='header'>
                    <h2>Восстановление доступа</h2>
                    <h3>Введите новый пароль</h3>
                </div>
                <div className="custom_divider"></div>
                <div className='body'>
                    {profile.auth ?
                        <>
                            <div className='result'>
                                <>
                                    <h3>Вы авторизованы</h3>
                                </>
                            </div>
                        </>
                        :
                        <>
                            {profile.loading ?
                                <Skeleton.Button style={{marginBottom: '20px',width:260,height:50}} shape="round" active block={false} />
                            :
                            <Form name="form" className="form" form={form_password} onFinish={form_finish_profile_password} >
                                <label style={{marginTop:20}}>Новый пароль</label>
                                <Form.Item  name={`password_new`} rules={[{ required: true, message: `Пожалуйста, введите новый пароль!` }]}>
                                    <Input.Password onChange={(e) => onChangePassword(e)} disabled={profile.loading} className='custom_input' placeholder={`•••••••••`} />
                                </Form.Item>
                                <Progress percent={password_complexity} />
                                <div className='form_buttons'>
                                    <Button className='submit' htmlType="submit" loading={profile.loading}>Сохранить</Button>
                                </div>
                            </Form>
                            }
                        </>
                    }
                </div>
                <div className='footer'>
                    
                </div>
            </Modal>
            <Modal mask centered className="modal_custom modal_authorization" key="m_forgot_code" width={700} title="Восстановление доступа" open={app_global.active_modal === 'forgotProfileCode'} onOk={() => closeModalForgotCode()} onCancel={() => closeModalForgotCode()} footer={null}>
                <div className='header'>
                    <h2>Восстановление доступа</h2>
                    <h3>Введите код</h3>
                </div>
                <div className="custom_divider"></div>
                <div className='body'>
                    {profile.auth ?
                        <>
                            <div className='result'>
                                <>
                                    <h3>Вы авторизованы</h3>
                                </>
                            </div>
                        </>
                        :
                        <div className="block_pin">
                            {profile.loading ?
                                <Skeleton.Button style={{marginBottom: '20px',width:260,height:50}} shape="round" active block={false} />
                            :
                                <ReactCodeInput
                                    type="number"
                                    fields={6}
                                    onChange={(e) => form_finish_forgot_code(e)}
                                />
                            }
                        </div>
                    }
                </div>
                <div className='footer'>
                    
                </div>
            </Modal>
            <Modal mask centered className="modal_custom modal_authorization" key="m_authorization" width={700} title="Авторизация" open={app_global.active_modal === 'authorization'} onOk={() => closeModalAuthorization()} onCancel={() => closeModalAuthorization()} footer={null}>
                <div className='header'>
                    <h2>Авторизация</h2>
                    <h3>в портале для медицинских учреждений</h3>
                </div>
                <div className="custom_divider"></div>
                <div className='body'>
                    {profile.auth ?
                        <>
                            <div className='result'>
                                <>
                                    <h3>Вы уже зарегистрированы</h3>
                                </>
                            </div>
                        </>
                        :
                        <>
                            <Form name="form" className="form" form={form_authorization} onFinish={form_finish_authorization}>
                                <Radio.Group style={{display:'none'}} className='radio_login' onChange={(e) => {setActiveTypeAuth(e.target.value); form_authorization.setFieldsValue({login:''})}} defaultValue="phone">
                                    <Radio.Button value="phone">Вход по номеру</Radio.Button>
                                    <Radio.Button value="email">Вход по почте</Radio.Button>
                                </Radio.Group>
                                {activeTypeAuth === 'phone' ? 
                                    <>
                                    <label>Телефон</label>
                                    <Form.Item name={`login`} rules={[{ required: true, message: `Пожалуйста, введите номер телефона!` }]}>
                                        <MaskedInput
                                            disabled={app_global.loading}
                                            mask={SETTINGS_APP.mask[SETTINGS_APP.project_format]['account']}
                                            placeholder={SETTINGS_APP.mask[SETTINGS_APP.project_format]['placeholder']}
                                            render={(ref, props) => (
                                                <input className="ant-input custom_input" type="text" aria-required="true" ref={ref} {...props} />
                                            )}
                                        />
                                    </Form.Item>
                                    </>
                                :
                                    <>
                                        <label>E-mail</label>
                                        <Form.Item name={`login`} rules={[{ required: true, message: `Пожалуйста, введите email!` }]}>
                                            <MaskedInput
                                                disabled={app_global.loading}
                                                mask={emailMask}
                                                placeholder="mail@52c.ru"
                                                render={(ref, props) => (
                                                    <input className="ant-input custom_input" type="text" aria-required="true" ref={ref} {...props} />
                                                )}
                                            />
                                        </Form.Item>
                                    </>
                                }
                                <label>Пароль</label>
                                <Form.Item name="password" rules={[{ required: true, message: 'Пожалуйста, введите пароль!' }]} >
                                    <Input.Password disabled={app_global.loading} className='custom_input' type="password" placeholder="••••••••••" iconRender={visible => (visible ? <EyeOutlined style={{color:'#9B9B9B'}} /> : <EyeInvisibleOutlined style={{color:'#9B9B9B'}} />)} />
                                </Form.Item>
                                <span className='forgot_password' onClick={() => showModalForgot()}>Забыли пароль?</span>
                                <div className='form_buttons'>
                                    <Button className='button_left' onClick={() => showModalRegistration()}>Создать новый аккаунт</Button>
                                    <Button className='submit' htmlType="submit" loading={app_global.loading}>Войти</Button>
                                </div>
                            </Form>
                        </>
                    }
                </div>
                <div className='footer'>
                    
                </div>
            </Modal>
            <Modal mask centered className="modal_custom modal_authorization" key="m_registration" width={700} title="Регистрация" open={app_global.active_modal === 'registration'} onOk={() => closeModalRegistration()} onCancel={() => closeModalRegistration()} footer={null}>
                <div className='header'>
                    <h2>Регистрация</h2>
                    <h3>в портале для медицинских учреждений</h3>
                </div>
                <div className="custom_divider"></div>
                <div className='body'>
                    {profile.auth ?
                        <>
                            {
                                Object.keys(profile?.registration).length > 0 ?
                                    <div className='result'>
                                        <h3>Успешная регистрация!</h3>
                                        <p className='text'>Ваш пароль:</p>
                                        <p className='password'>{profile?.registration?.password}</p>
                                    </div>
                            :
                                <div className='result'>
                                    <>
                                        <h3>Вы уже зарегистрированы</h3>
                                    </>
                                </div>
                            }
                        </>
                        :
                        <>
                            {
                                Object.keys(profile?.registration).length > 0 ?
                                    <div className='result'>
                                        <h3>Успешная регистрация!</h3>
                                        <p className='text'>Ваш пароль:</p>
                                        <p className='password'>{profile?.registration?.password}</p>
                                    </div>
                                :
                                <Form name="form" className="form default_form" form={form_registration} onFinish={form_finish_registration}>
                                    <label>Имя</label>
                                    <Form.Item name={`firstname`} rules={[{ required: true, message: `Пожалуйста, введите Ваше имя!` }]}>
                                        <Input disabled={app_global.loading} className='custom_input' placeholder={randomUser['firstname']} />
                                    </Form.Item>
                                    <label>Фамилия</label>
                                    <Form.Item name={`lastname`} >
                                        <Input disabled={app_global.loading} className='custom_input' placeholder={randomUser['lastname']} />
                                    </Form.Item>
                                    <label>Пол</label>
                                    <Form.Item name={`gender`} rules={[{ required: true, message: `Пожалуйста, укажите пол!` }]}>
                                        <Select
                                            disabled={app_global.loading}
                                            className="custom_select"
                                            showSearch
                                            placeholder="Выбрать пол"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                            }
                                            options={[
                                                {value:"1",label:"Мужской"},
                                                {value:"2",label:"Женский"}
                                            ]}
                                        />
                                    </Form.Item>
                                    { 1 === 2 ?
                                        <>
                                            <label>Телефон</label>
                                            <Form.Item name={`phone`} rules={[{ required: true, message: `Пожалуйста, введите номер телефона!` }]}>
                                                <MaskedInput
                                                    disabled={app_global.loading}
                                                    mask={SETTINGS_APP.mask[SETTINGS_APP.project_format]['account']}
                                                    placeholder={SETTINGS_APP.mask[SETTINGS_APP.project_format]['placeholder']}
                                                    render={(ref, props) => (
                                                        <input className="ant-input custom_input" type="text" aria-required="true" ref={ref} {...props} />
                                                    )}
                                                />
                                            </Form.Item>
                                        </>
                                        :
                                        null
                                    }
                                    { 1 === 1 ?
                                        <>
                                            <label>E-mail</label>
                                            <Form.Item name={`email`} rules={[{ required: true, message: `Пожалуйста, введите email!` }]} >
                                                <MaskedInput
                                                    disabled={app_global.loading}
                                                    mask={emailMask}
                                                    placeholder="mail@52c.ru"
                                                    render={(ref, props) => (
                                                        <input className="ant-input custom_input" type="text" aria-required="true" ref={ref} {...props} />
                                                    )}
                                                />
                                            </Form.Item>
                                        </>
                                        :
                                        null
                                    }
                                    
                                    <span className='forgot_password' onClick={() => showModalForgot()}>Забыли пароль?</span>
                                    <div className='form_buttons'>
                                        <Button className='button_left' onClick={() => showModalAuthorization()}>У меня есть аккаунт</Button>
                                        <Button className='submit' htmlType="submit" loading={app_global.loading}>Создать</Button>
                                    </div>
                                </Form>
                            }
                        </>
                    }
                </div>
                <div className='footer'>
                    
                </div>
            </Modal>
            <Modal mask centered className="modal_custom modal_authorization" key="m_forgot" width={700} title="Восстановление доступа" open={app_global.active_modal === 'forgot'} onOk={() => closeModalForgot()} onCancel={() => closeModalForgot()} footer={null}>
                <div className='header'>
                    <h2>Восстановление доступа</h2>
                    <h3>в портале для медицинских учреждений</h3>
                </div>
                <div className="custom_divider"></div>
                <div className='body'>
                    {profile.auth ?
                        <>
                            <div className='result'>
                                <>
                                    <h3>Вы уже зарегистрированы</h3>
                                </>
                            </div>
                        </>
                        :
                        <>
                            <Form name="form" className="form" form={form_forgot} onFinish={form_finish_forgot}>
                                <Radio.Group style={{display:'none'}} className='radio_login' onChange={(e) => {setActiveTypeForgot(e.target.value); form_forgot.setFieldsValue({login:'',type:e.target.value})}} >
                                    <Radio.Button value="phone">По номеру</Radio.Button>
                                    <Radio.Button value="email">По почте</Radio.Button>
                                </Radio.Group>
                                <Form.Item hidden name={`type`} rules={[{ required: true, message: `Пожалуйста, введите тип!` }]}>
                                    <Input disabled={app_global.loading} className='custom_input' defaultValue={`phone`} />
                                </Form.Item>
                                {activeTypeForgot === 'phone' ? 
                                    <>
                                    <label>Телефон</label>
                                    <Form.Item name={`login`} rules={[{ required: true, message: `Пожалуйста, введите номер телефона!` }]}>
                                        <MaskedInput
                                            disabled={app_global.loading}
                                            mask={SETTINGS_APP.mask[SETTINGS_APP.project_format]['account']}
                                            placeholder={SETTINGS_APP.mask[SETTINGS_APP.project_format]['placeholder']}
                                            render={(ref, props) => (
                                                <input className="ant-input custom_input" type="text" aria-required="true" ref={ref} {...props} />
                                            )}
                                        />
                                    </Form.Item>
                                    </>
                                :
                                    <>
                                        <label>E-mail</label>
                                        <Form.Item name={`login`} rules={[{ required: true, message: `Пожалуйста, введите email!` }]}>
                                            <MaskedInput
                                                disabled={app_global.loading}
                                                mask={emailMask}
                                                placeholder="mail@52c.ru"
                                                render={(ref, props) => (
                                                    <input className="ant-input custom_input" type="text" aria-required="true" ref={ref} {...props} />
                                                )}
                                            />
                                        </Form.Item>
                                    </>
                                }
                                <div className='form_buttons'>
                                    <Button className='button_left' onClick={() => showModalAuthorization()}>Вернуться к форме входа</Button>
                                    <Button className='submit' htmlType="submit" loading={app_global.loading}>Продолжить</Button>
                                </div>
                            </Form>
                        </>
                    }
                </div>
                <div className='footer'>
                    
                </div>
            </Modal>
            <header className={activeMenu ? 'active':null}>
                <div className='container --header'>

                    <div className='content'>
                        <Button className='menu' type="text" shape="circle" onClick={() => setActiveMenu(!activeMenu)} icon={
                            activeMenu ? 
                            <CloseOutlined style={{ color: 'rgba(0,0,0,.45)', fontSize: 20 }} />
                            :
                            <MenuOutlined style={{ color: 'rgba(0,0,0,.45)', fontSize: 20 }} />
                        }></Button>
                        <Link to='/' exact={ true } onClick={() => scroll.scrollToTop()} className='icon__mp' >
                            <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                            </svg>
                        </Link>
                        <div className='search_block' >
                            <Input value="" onClick={() => refLinkOrgs.current.click()} className={`search_input ${activeCity ? 'activeCity':null}`} placeholder="Поиск по названию медицинского учреждения" bordered={false} onFocus={() => setActiveMenu(false)} 
                            prefix={
                                <SearchOutlined style={{ color: 'rgba(0,0,0,.45)', fontSize: 20 }} />
                            } 
                            addonAfter={
                                <>
                                <Button style={{display:!activeCity?'flex':'none'}} type="text" className='city' onClick={() => clickCity()}>
                                    <span className="icon"><MdOutlineHomeWork /></span>
                                    <span className="text">{locations.location?.city_name}</span>
                                    <span className="down"><BsChevronDown /></span>
                                </Button>
                                <Input onChange={searchCityF} ref={inputRef} style={{display:(activeCity)?'flex':'none'}} className='search_city' placeholder="Поиск города" suffix={<Button shape="circle" size='small' onClick={() => clickCity()} icon={<CloseCircleOutlined style={{color:'#9B9B9B'}} />} />} />
                                </>
                            }
                            />
                            {(activeCity && !activeMenu) ?
                                <div className='citys'>
                                    {
                                        obj.city.length ?
                                            <ul>
                                                {
                                                    obj.city.map((city, index) => 
                                                        <li className={`${city.id === clientCityId ? 'active' : null}`} onClick={() => changeCity(city)} key={city.key}>{city.city}</li>
                                                    )
                                                }
                                            </ul>
                                        :
                                        <span>
                                            Список пуст
                                        </span>
                                    }
                                </div>
                            :
                                null    
                            }
                        </div>
                        <Link className='mobile_hidden' to='/rating' exact={ true } onClick={() => scroll.scrollToTop()} >
                            <Button type="text" className='' >Народный рейтинг</Button>
                        </Link>
                        <Link className='mobile_hidden' to='/news_mz' exact={ true } onClick={() => scroll.scrollToTop()} >
                            <Button type="text" className='' >Новости минздрава</Button>
                        </Link>
                        <Input ref={inputSearchRef} className={`search_input_mobile ${activeSearch ? 'active':null}`} placeholder="Поиск по названию медицинского учреждения" bordered={false}
                        prefix={
                            <SearchOutlined style={{ color: 'rgba(0,0,0,.45)', fontSize: 20 }} />
                        }
                        suffix={<Button shape="circle" size='small' onClick={() => clickSearch()} icon={<CloseCircleOutlined style={{color:'#9B9B9B'}} />} />}
                        />
                        <span className='mobile_visible'>
                            <span className='a search' style={{display:activeSearch?'none':'block'}}>
                                <Button onClick={() => refLinkOrgs.current.click()} type="primary" shape="circle" size='large' ><SearchOutlined style={{ color: '#fff' }} /></Button>
                            </span>
                            <span className='a search'>
                                {
                                    profile.auth ?
                                    <Link to='/profile' exact={ true } onClick={() => scroll.scrollToTop()} className='ant-btn ant-btn-circle ant-btn-primary ant-btn-lg' ><span><UserOutlined style={{ color: '#fff' }} /></span></Link>
                                    :
                                    <Button onClick={() => showModalAuthorization()} type="primary" shape="circle" size='large' ><UserOutlined style={{ color: '#fff' }} /></Button>
                                }
                            </span>
                        </span>
                        <div className='mobile_hidden button_auth' >
                            {
                                profile.auth ?
                                <Link to='/profile' exact={ true } onClick={() => scroll.scrollToTop()} loading={app_global.loading} className='ant-btn ant-btn-primary' ><span>Профиль</span></Link>
                                :
                                <Button loading={app_global.loading} type="primary" className='' onClick={() => showModalAuthorization()} >Войти</Button>
                            }
                        </div>
                    </div>
                </div>
                <div className='menu_mobile'>
                    <div className='container'>
                        <div className='content'>
                            <div className='head'>
                                <div className='head_container'>
                                    <Button className='menu' type="text" shape="circle" onClick={() => setActiveMenu(!activeMenu)} icon={
                                        activeMenu ? 
                                        <CloseOutlined style={{ color: 'rgba(0,0,0,.45)', fontSize: 20 }} />
                                        :
                                        <MenuOutlined style={{ color: 'rgba(0,0,0,.45)', fontSize: 20 }} />
                                    }></Button>
                                    <Link to='/' exact={ true } onClick={() => scroll.scrollToTop()} className='icon__mp' onClick={() => setActiveMenu(false)} >
                                        <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                                        </svg>
                                    </Link>
                                </div>
                                <div className={`search_group ${activeCity?'active':null}`}>
                                    <div className='search_group_content'>
                                        <Button style={{display:!activeCity?'flex':'none'}} type="text" className='city' onClick={() => clickCityMob()}>
                                            <span className="icon"><MdOutlineHomeWork /></span>
                                            <span className="text">{locations.location?.city_name}</span>
                                            <span className="down"><BsChevronDown /></span>
                                        </Button>
                                        <Input onChange={searchCityF} ref={inputMobRef} style={{display:activeCity?'flex':'none'}} className='search_city' placeholder="Поиск города" suffix={<Button shape="circle" size='small' onClick={() => clickCityMob()} icon={<CloseCircleOutlined style={{color:'#9B9B9B'}} />} />} />
                                    </div>
                                    {activeCity ?
                                        <div className='citys'>
                                            {
                                                obj.city.length ?
                                                    <ul>
                                                        {
                                                            obj.city.map((city, index) => 
                                                                <li className={`${city.id === clientCityId ? 'active' : null}`} onClick={() => changeCity(city)} key={city.key}>{city.city}</li>
                                                            )
                                                        }
                                                    </ul>
                                                :
                                                <span>
                                                    Список пуст
                                                </span>
                                            }
                                        </div>
                                    :
                                        null    
                                    }
                                </div>
                            </div>
                            <ul className='menu_mobile_list'>
                                {
                                    profile.auth ?
                                    <Link className="button_profile" to='/profile' exact={ true } onClick={() => scroll.scrollToTop()} onClick={() => setActiveMenu(false)} >
                                        <span>Профиль</span>
                                    </Link>
                                    :
                                    <li className="button_profile" onClick={ () => showModalAuthorization() }>
                                        <span>Войти</span>
                                    </li>
                                }
                                <Link to='/' exact={ true } onClick={() => scroll.scrollToTop()} onClick={() => setActiveMenu(false)} >
                                    <span>Главная</span>
                                </Link>
                                <Link to='/rating' exact={ true } onClick={() => scroll.scrollToTop()} onClick={() => setActiveMenu(false)} >
                                    <span>Народный рейтинг</span>
                                </Link>
                                <Link to='/news_mz' exact={ true } onClick={() => scroll.scrollToTop()} onClick={() => setActiveMenu(false)} >
                                    <span>Новости минздрава</span>
                                </Link>
                                <Link to='/news' exact={ true } onClick={() => scroll.scrollToTop()} onClick={() => setActiveMenu(false)} >
                                    <span>Новости проекта</span>
                                </Link>
                                <Link to='/articles' exact={ true } onClick={() => scroll.scrollToTop()} onClick={() => setActiveMenu(false)} >
                                    <span>Статьи</span>
                                </Link>
                                <Link to='/org' exact={ true } onClick={() => scroll.scrollToTop()} onClick={() => setActiveMenu(false)} >
                                    <span>Медицинские организации</span>
                                </Link>
                                <Link to='/search_doctor' exact={ true } onClick={() => scroll.scrollToTop()} onClick={() => setActiveMenu(false)} >
                                    <span>Найти специалиста</span>
                                </Link>
                                <Link to='/job' exact={ true } onClick={() => scroll.scrollToTop()} onClick={() => setActiveMenu(false)} >
                                    <span>Вакансии</span>
                                </Link>
                                <Link to='/specializations' exact={ true } onClick={() => scroll.scrollToTop()} onClick={() => setActiveMenu(false)} >
                                    <span>Направления медицины</span>
                                </Link>
                                <Link to='/symptoms' exact={ true } onClick={() => scroll.scrollToTop()} onClick={() => setActiveMenu(false)} >
                                    <span>Изучить симптоматику</span>
                                </Link>
                                <Link to='/food_products' exact={ true } onClick={() => scroll.scrollToTop()} onClick={() => setActiveMenu(false)} >
                                    <span>Топ 10 продуктов питания</span>
                                </Link>
                                <Link style={{marginTop: 10}} className='button_profile' to='/surveys' exact={ true } onClick={() => scroll.scrollToTop()} onClick={() => setActiveMenu(false)} >
                                    <span>Медицинские тесты</span>
                                </Link>
                            </ul>
                        </div>
                    </div>
                    <div className='mask-container' onClick={() => setActiveMenu(!activeMenu)}>

                    </div>
                </div>
            </header>
        </>
    );
};